/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import axios from 'axios';
import { t } from 'ttag';

import setLanguage from '../translations/general_trans';
import GenericPopup from '../../reusable-components/GenericPopup/GenericPopup';
// eslint-disable-next-line import/no-named-as-default
import isEmail from '../../utils/isEmail';

// Check if there is whitespace or empty
function isNotEmpty(value) {
  if (value.replace(/\s/g, '').length) {
    return true;
  }
  return false;
}

export default class EmailStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPopup1: false,
      showPopup2: false,
      email: '',
      emailActive: false,
      emailWarning: '',
      showGeneralErr: false,
      onChecked: null,
      gTrans: setLanguage('general', window.config.language_code)
    };
  }

  componentDidMount() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      // Create intersectionObserver
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      const observer = new window.IntersectionObserver(this.callback, options);
      const target = this.props.flag
        ? document.querySelector('#footer')
        : document.querySelector('.newsletter-main');
      observer.observe(target);
    } else {
      this.getPermissions();
    }
  }

  // Start set active
  setActive(active) {
    if (active === 'email') {
      this.setState({
        emailActive: true
      });
      if (this.state.onChecked === true) {
        this.setState({
          emailActive: true
        });
      }
    }
  }

  setPopup(popupNr) {
    this.setState(prevState => {
      return {
        [`showPopup${popupNr}`]: !prevState[`showPopup${popupNr}`]
      };
    });
  }

  // Start email
  handleEmailActive() {
    this.setActive('email');
  }

  getText() {
    return { __html: this.state.text };
  }

  getPermissions = () => {
    axios.get('/policies/short_permission/').then(response => {
      // console.log('response', response);
      this.setState({
        text: response.data.permission_text
      });
    });
  };

  callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        this.getPermissions();
        if (observer) {
          observer.disconnect();
        }
      }
    });
  };

  handleEmailInput(event) {
    this.setState({ email: event.target.value });
    this.validateEmail(event.target.value);
  }

  validateEmail(email) {
    if (isNotEmpty(email) && isEmail(email)) {
      this.setState({ emailWarning: false });
    } else if (!isNotEmpty(email)) {
      this.setState(prevState => ({ emailWarning: prevState.gTrans.error7 }));
    } else if (!isEmail(email)) {
      this.setState(prevState => ({ emailWarning: prevState.gTrans.error3 }));
    }
    return false;
  }

  handleData(event) {
    try {
      event.preventDefault();
      this.validateEmail(this.state.email);
      // this.validateCheckbox(this.state.onCheck);
      if (this.state.emailWarning === false && this.state.onChecked === true) {
        this.props.onNextClick(this.state.email);
      } else if (this.state.onChecked === null) {
        this.setState({
          onChecked: false
        });
      } else {
        this.setState({
          emailActive: true
        });
      }
    } catch (error) {
      this.setState({
        showGeneralErr: true
      });
    }
  }

  render() {
    const { gTrans } = this.state;
    return (
      <section className="email-section">
        <div className="signupWrapper">
          <h1 className="mb-5 mt-0 text-center text-xl font-semibold">
            {gTrans.headlineStep1}
          </h1>
          {this.state.showGeneralErr === true && (
            <p className="generalErr">{this.state.gTrans.error5}</p>
          )}
          <div
            id="email"
            className={this.state.emailActive ? 'active relative' : 'relative'}
          >
            <label htmlFor="email">{gTrans.email}</label>
            <input
              className={this.state.emailWarning ? 'redBottom' : 'noBottom'}
              type="text"
              name="email"
              aria-label={gTrans.email}
              value={this.state.email}
              autoComplete="off"
              required=""
              onFocus={event => this.handleEmailActive(event)}
              onChange={event => this.handleEmailInput(event)}
            />
            <button
              type="button"
              className="signup"
              onClick={event => this.handleData(event)}
            >
              {gTrans.ctaSignup}
            </button>
            <div className="svgError">
              <svg
                className={this.state.emailWarning ? '' : 'hide'}
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path
                  strokeWidth="1px"
                  fill="red"
                  stroke="red"
                  d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
                />
              </svg>
            </div>
          </div>
          <p className="emailWarning">{this.state.emailWarning}</p>
          <div
            id="terms"
            className={this.state.emailActive ? 'active relative' : 'relative'}
          >
            <div htmlFor="container" className="container">
              <input
                className="checkbox"
                type="checkbox"
                aria-label="Checkbox"
                required=""
                onChange={event =>
                  this.setState({ onChecked: event.target.checked })
                }
              />
              <span
                className={
                  this.state.onChecked === false ? 'checkmarkRed' : 'checkmark'
                }
              >
                {' '}
              </span>
              <p
                className="termsAndConditions"
                dangerouslySetInnerHTML={this.getText()}
              />
              {this.state.showPopup1 && (
                <GenericPopup
                  title={t`Read our terms`}
                  closeModal={() => this.setPopup(1)}
                  type="policy"
                  name="long_permission"
                  target=".site-modal"
                />
              )}
              {this.state.showPopup2 && (
                <GenericPopup
                  title={t`Privacy policy`}
                  closeModal={() => this.setPopup(2)}
                  type="policy"
                  name="privacy"
                  target=".site-modal"
                />
              )}
              <div className="terms_link_wrapper termsAndConditions">
                <span
                  className="popup-link"
                  role="button"
                  tabIndex={0}
                  onClick={() => this.setPopup(1)}
                >{t`Read our terms`}</span>
                {' | '}
                <span
                  className="popup-link"
                  role="button"
                  tabIndex={0}
                  onClick={() => this.setPopup(2)}
                >{t`Privacy policy`}</span>
              </div>
            </div>
          </div>
          <div>
            {this.state.onChecked === false && (
              <p
                className={
                  this.state.gTrans.confirmConsentText ? 'termsWarning' : 'hide'
                }
              >
                {this.state.gTrans.confirmConsentText}
              </p>
            )}
          </div>
        </div>
      </section>
    );
  }
}
